import moment from "moment";

export const formatDate = (date) => moment(date).utc().format("YYYY-MM-DD");

export const getDayOfMonth = (day, month) =>
  moment(month)
    .add(day - 1, "day")
    .format("YYYY-MM-DD");

export const isWeekend = (date) => moment(date).format("dd")[0] === "S";

export const isSunday = (date) => moment(date).format("dd") === "Su";

export const isInPast = (date) =>
  moment(date).endOf("day").diff(moment().endOf("day")) < 0;

export const encodeDateURI = (date) =>
  encodeURIComponent(moment(date).format("YYYY-MM-DD HH:mm:ss"));

export const isWeekAfter = (date) => {
  return moment().endOf("day").diff(moment(date).endOf("day")) > 0;
};
